import { Box, Grid } from "@mui/material";
import {
  DateRangePicker,
  SingleInputDateRangeField,
} from "@mui/x-date-pickers-pro";
import { shortcuts } from "../../utils/Dates";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import { useContext } from "react";
import { Context } from "../table/timecard/Context";

// Audit
const FilterTotal = ({ loading }) => {
  const { t } = useTranslation("filter");
  const { t: tUtils } = useTranslation("utils");

  const { employee, range3, setRange3, gettingTotal } = useContext(Context);

  const searching = () => {
    gettingTotal(range3, employee);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 2,
          p: 1.5,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <DateRangePicker
              label={t("filter_totals.range_of_days")}
              slots={{ field: SingleInputDateRangeField }}
              slotProps={{
                shortcuts: {
                  items: shortcuts(tUtils),
                },
              }}
              format={JSON.parse(sessionStorage.getItem("config")).date_format}
              calendars={1}
              fullwith
              onAccept={(value) => {
                setRange3(value);
              }}
              value={range3}
              sx={{
                width: "100%",
              }}
            />
          </Grid>

          <Grid item xs={6} />

          <Grid item xs={2}>
            <LoadingButton
              sx={{ position: "absolute", right: "15px", height: "56px" }}
              loading={loading}
              variant="contained"
              onClick={searching}
              disableElevation
            >
              {t("filter_totals.search")}
            </LoadingButton>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export { FilterTotal };
